import React from 'react'
import { LOGOS } from '../lib/logos'

// Inline brand logo in its official color (pass color="current" to inherit instead).
export function Logo({ slug, size = 22, color, className = '' }) {
  const l = LOGOS[slug]
  if (!l) return null
  const fill = color === 'current' ? 'currentColor' : (color || l.hex || 'currentColor')
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} role="img" aria-label={l.title} className={className}>
      <path fill={fill} d={l.path} />
    </svg>
  )
}

const GROUPS = [
  { title: 'Data sources', note: 'Feed any instance from anywhere — website, files, or these systems.', items: ['postgresql', 'mysql', 'microsoftsqlserver', 'amazonwebservices', 'googlecloud', 'microsoftazure', 'confluence', 'jira', 'salesforce', 'sap', 'notion', 'slack'] },
  { title: 'Channels', note: 'Your assistant answers where your customers already are.', items: ['slack', 'whatsapp'] },
  { title: 'Agents & automation', note: 'Connect it to Claude / Cursor over MCP, or let it act through your tools.', items: ['modelcontextprotocol', 'claude', 'cursor', 'twilio', 'gmail', 'googlecalendar'] },
]

const Tile = ({ slug }) => {
  const l = LOGOS[slug]
  if (!l) return null
  return (
    <div className="flex flex-col items-center gap-2 group">
      <div className="w-14 h-14 rounded-xl bg-white border border-gray-200 flex items-center justify-center shadow-sm group-hover:border-gray-300 group-hover:shadow transition-all">
        <Logo slug={slug} size={26} />
      </div>
      <span className="text-[11px] text-gray-600 text-center">{l.title}</span>
    </div>
  )
}

export default function Integrations() {
  return (
    <section id="integrations" className="scroll-mt-16 bg-gray-50 border-y border-gray-200">
      <div className="max-w-6xl mx-auto px-5 py-16">
        <h2 className="text-2xl font-display font-black tracking-tight mb-2">Connect what you already use</h2>
        <p className="text-gray-500 mb-10 max-w-2xl">Point an instance at any source, answer on any channel, and drive it all from your own agent — over the Model Context Protocol.</p>
        <div className="space-y-10">
          {GROUPS.map((g) => (
            <div key={g.title}>
              <div className="flex items-baseline justify-between flex-wrap gap-2 mb-4">
                <h3 className="font-bold text-gray-900">{g.title}</h3>
                <p className="text-sm text-gray-500">{g.note}</p>
              </div>
              <div className="grid grid-cols-3 sm:grid-cols-6 gap-x-4 gap-y-6">
                {g.items.map((slug) => <Tile key={slug + g.title} slug={slug} />)}
              </div>
            </div>
          ))}
        </div>
        <p className="text-xs text-gray-400 mt-8">Logos are trademarks of their respective owners, shown to indicate supported integrations.</p>
      </div>
    </section>
  )
}
